/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthSubmissionListEntry } from './PalReauthSubmissionListEntry';
import {
    PalReauthSubmissionListEntryFromJSON,
    PalReauthSubmissionListEntryFromJSONTyped,
    PalReauthSubmissionListEntryToJSON,
    PalReauthSubmissionListEntryToJSONTyped,
} from './PalReauthSubmissionListEntry';

/**
 * 
 * @export
 * @interface FindAllPalReauthSubmissionsResponse
 */
export interface FindAllPalReauthSubmissionsResponse {
    /**
     * 
     */
    data: Array<PalReauthSubmissionListEntry>;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
    /**
     * User lookup map keyed by user_id. Each value matches the LeadAssignmentUser shape. Typed as an open object because the openapi-generator's TypeScript template emits broken FromJSON for typed-additionalProperties Records; consumers cast at use site.
     */
    users_sidecar?: { [key: string]: any; };
}

/**
 * Check if a given object implements the FindAllPalReauthSubmissionsResponse interface.
 */
export function instanceOfFindAllPalReauthSubmissionsResponse(value: object): value is FindAllPalReauthSubmissionsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function FindAllPalReauthSubmissionsResponseFromJSON(json: any): FindAllPalReauthSubmissionsResponse {
    return FindAllPalReauthSubmissionsResponseFromJSONTyped(json, false);
}

export function FindAllPalReauthSubmissionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalReauthSubmissionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PalReauthSubmissionListEntryFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
        'users_sidecar': json['users_sidecar'] == null ? undefined : json['users_sidecar'],
    };
}

export function FindAllPalReauthSubmissionsResponseToJSON(json: any): FindAllPalReauthSubmissionsResponse {
    return FindAllPalReauthSubmissionsResponseToJSONTyped(json, false);
}

export function FindAllPalReauthSubmissionsResponseToJSONTyped(value?: FindAllPalReauthSubmissionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(PalReauthSubmissionListEntryToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
        'users_sidecar': value['users_sidecar'],
    };
}

